import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {TimesIcon} from 'shells/icon';
import CheckmarkSVG from 'shells/modal/step-modal/checkmark.svg';

import {colors} from '../../colors/colors';
import {ProgressBar} from '../../progress-bar/progress-bar';

import styles from './step-list.module.css';

type Skip = {
    index: number;
    description: string;
};

type Props = {
    activeStepIndex: number;
    skips: Skip[];
    steps: string[];
};

StepList.defaultProps = {
    skips: [],
};

export function StepList(props: Props) {
    return (
        <ol className={styles.list}>
            {props.steps.map((step, index) => {
                const stepSkip = props.skips.find((skip) => skip.index === index);

                return (
                    <Step
                        key={step}
                        step={step}
                        isComplete={index < props.activeStepIndex && !stepSkip}
                        isActive={index === props.activeStepIndex}
                        stepSkip={stepSkip}
                    />
                );
            })}
        </ol>
    );
}

type StepProps = {
    step: string;
    isComplete: boolean;
    isActive: boolean;
    stepSkip: Skip | null | undefined;
};

function Step(props: StepProps) {
    const {step, isActive, isComplete, stepSkip} = props;
    const [showCheckmark, setShowCheckmark] = React.useState<boolean>(isComplete);
    const [showX, setShowX] = React.useState<boolean>(Boolean(stepSkip));

    React.useEffect(() => {
        if (!isComplete && showCheckmark) {
            setShowCheckmark(false);
        }
        if (!stepSkip && showX) {
            setShowX(false);
        }
    }, [isComplete, showX, stepSkip, showCheckmark]);

    let styleName = styles.step;
    if (isActive) {
        styleName = styles['step--active'];
    } else if (stepSkip) {
        styleName = styles['step--skipped'];
    }

    return (
        <li key={step} className={styleName}>
            <div>{step}</div>
            <div className={styles.strikethrough}>
                <ProgressBar
                    color={colors.offWhite}
                    percentComplete={isComplete || stepSkip ? 1 : 0}
                    onAnimationComplete={() => {
                        if (isComplete) setShowCheckmark(true);
                        if (stepSkip) {
                            setShowX(true);
                            ReactTooltip.rebuild();
                        }
                    }}
                />
            </div>
            {showCheckmark ? (
                <div className={styles.checkmark}>
                    <CheckmarkSVG />
                </div>
            ) : null}
            {showX && stepSkip ? (
                <div data-tip={stepSkip.description} className={styles.x}>
                    <TimesIcon />
                </div>
            ) : null}
        </li>
    );
}
